<template>
    <div>
        <template v-if="!edit">
                <div class="demo-upload-list" v-if="show" v-for='(file,index) in uploadList'>
                  <p width="50px" height="50px">{{file.name}}</p>
                  <div class="demo-upload-list-cover">
                    <Icon type="ios-trash-outline" @click.native="handleRemove(index,file.name)"></Icon>
                  </div>
                </div>
                <div id='ossfile' v-if="upImg" style='overflow: hidden;position: relative;margin-bottom: 10px;'>
                    <p class='file-box' style='float:left;max-width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;' v-for='file in fileList'>{{file.name}}</p>
                    <div class='progress-box' style='width:100px;height:4px;position: absolute;bottom: 0px;border-radius: 2px;overflow: hidden;'>
                        <div class='progress' style='height:4px;background-color: rgb(92, 184, 92);' :style="{'width':progressWidth}">
                        
                        </div>
                    </div>
                    <div class='upload-btn' style='float:left;' @click='uploadImg'>
                        开始上传
                    </div>
                </div>
                <div id='container'>
                    <Button id='choosefile' :loading="loading" type="dashed"> 
                    
                        <div style="width: 28px;height:28px;line-height: 28px;">
                           <Icon type="md-musical-note" size='20'/>
                        </div>
                    </Button>
                </div>
        </template>
    </div>
</template>

<script>
    import {
        uploadFile
    } from '@/api/common'
    import md5  from 'js-md5';
    
    export default {
        props: ['getList', 'message'],        
        name: "upload",
        data() {
            return {
                loading: false,
                visible: false,
                show: false,
                upImg:false,
                videoUrl: "",
                urls: [],
                fileList: [],
                edit: false,
                uploader:'',
                timestamp:'',
                multipart_params:{},
                progressWidth:'0%',
                uploadList:[],
                key:'',
            };
        },
        created() {
            if(this.getList!=''){
                var obj={
                    url:this.getList,
                    name:this.getList
                };
                this.uploadList.push(obj);
                this.show=true;
            }
        },
        mounted() {
                   uploadFile({
                        dir: 'audio/'
                    }).then(res => {
                        res = res.data;
                        if (res.code == 200) {
                            var _this=this;
                            this.multipart_params={
                                key:res.data.dir,
                                policy:res.data.policy,
                                OSSAccessKeyId:res.data.accessid,
                                success_action_status:'200',
                                signature:res.data.signature,
                                expire:parseInt(res.data.expire),
                            };
                            this.key=res.data.dir;
                            this.uploader = new plupload.Uploader({
                            runtimes: 'html5,flash,silverlight,html4',
                            browse_button: 'choosefile',
                            // container: document.getElementById('container'),
                            flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
                            silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
                            filters: {
                                mime_types : [ //只允许上传图片和zip,rar文件
                                { title : "apk files", extensions : "MP3,wav" }, 
                                ],
                                max_file_size : '10mb', //最大只能上传10mb的文件
                                prevent_duplicates : false //不允许选取重复文件
                            },
                            url: res.data.host,
                            multipart_params:{
                               
                                policy:res.data.policy,
                                OSSAccessKeyId:res.data.accessid,
                                success_action_status:'200',
                                signature:res.data.signature,
                                expire:parseInt(res.data.expire),
                            },
                            init: {
                                PostInit: function() {
                                    // document.getElementById('postfiles').onclick = function() {
                                        // set_upload_param(uploader);
                                        // return false;
                                    // };
                                },
                                FilesAdded: function(up, files) {    
                                    // 上传添加图片事件
                                     if(_this.message<=_this.uploadList.length||_this.message<up.files.length||files.length>_this.message){
                                        _this.$Notice.warning({
                                            title: '最多只能上传 '+_this.message+'张图片。'
                                        });
                                        files.forEach(function(item){
                                            _this.uploader.removeFile(item)
                                        })

                                    }else{
                                        _this.upImg=true;
                                        _this.fileList=files;
                                   
                                        files.forEach(function(item){
                                            var pos = item.name.lastIndexOf('.')
                                            if (pos != -1) {
                                                var suffix = item.name.substring(pos);
                                                var num = Math.random()*800000 + 100000;
                                                num = parseInt(num, 10);
                                                item.name = md5(new Date().getTime() + '_' + num) + suffix;
                                            }

                                        })
                                    }
                                },
                                BeforeUpload(uploader,file){
                                    _this.multipart_params.key=_this.key+file.name;
                                    _this.uploader.setOption({
                                        'multipart_params': _this.multipart_params
                                    });

                                },
                                UploadProgress: function(up, file) {
                                    // 上传过程事件
                                    _this.progressWidth=file.percent+'%'
                                    if(file.percent==100){
                                        _this.upImg=false;
                                        _this.progressWidth='0%';
                                    }
                                },
                                FileUploaded: function(up, file, info) {
                                    console.log(file)
                                    _this.show=true;
                                    var imgurl='/audio/'+file.name;
                                    var obj={
                                        name:file.name,
                                        url:imgurl
                                    }
                                    _this.uploadList.push(obj)
                                    _this.$emit('getAudioList', _this.uploadList);
                                },
            
                                Error: function(up, err) {
                                    // 上传错误
                                    if (err.code == -600) {
                                        _this.$Notice.warning({
                                            title: '超出文件大小限制',
                                            desc: '文件 ' + err.file.name + ' 太大.'
                                        });
                                    }else if (err.code == -601) {
                                        _this.$Notice.warning({
                                            title: '文件格式不正确',
                                            desc: '文件 ' + err.file.name + ' 格式不正确，请上传 jpg 或 png 格式的图片。'
                                        });
                                    }else if (err.code == -602) {
                                        _this.$Notice.warning({
                                            title: '文件重复',
                                            desc: '这个文件已经上传过一遍了'
                                        });
                                    }else {
                                        _this.$Notice.warning({
                                            desc: err.response
                                        });
                                    }
                                    // set_upload_param(up);
                                    // document.getElementById('console').appendChild(document.createTextNode("\nError xml:" + err.response));
                                }
                            }
                        });
                        this.uploader.init();
                        } else if (res.code == 14001) {
                            this.$store.commit('logout', this);
                            this.$store.commit('clearOpenedSubmenu');
                            this.$router.push({
                                name: 'login'
                            });
                            this.$Message.error(res.msg);
                        } else {
                            this.$Message.error(res.msg);
                        }
                    })      
        },
        methods: {
            uploadImg() {
               
                this.uploader.start();
            },
            handleView(url) {
                //预览
                this.visible = true;
                this.videoUrl=url;
            },
            cancelVideo(){
                this.visible = false;
                
            },
            handleRemove(index) {
                //删除图片
                this.uploadList.splice(index, 1);
                this.$emit('getAudioList', this.uploadList);
            }
        },
    };
</script>

<style scoped>
    .upload-btn{
        float:left;
        width:80px;
        background:#57a3f3;
        color: #fff;
        text-align: center;
        margin-left: 50px;
        border-radius: 4px;
        cursor: pointer;
    }
    .ivu-btn {
        padding: 10px;
    }
    
    .file {
        display: none;
    }
    
    .demo-upload-list {
        display: inline-block;
        width: 300px;
        height: 30px;
        text-align: center;
        line-height: 36px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
        margin-right: 4px;
    }
    
    .demo-upload-list img {
        width: 100%;
        height: 100%;
    }
    
    .demo-upload-list-cover {
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.6);
    }
    
    .demo-upload-list:hover .demo-upload-list-cover {
        display: block;
    }
    
    .demo-upload-list-cover i {
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
</style>